/**
 * PHFFeatures
 *
 * Two-column section with a photo on the left and a navy background
 * content panel on the right. Displays an orange title, white subtext,
 * and a list of items with shield checkmark icons.
 *
 * Props:
 * - image (string, required): URL for the left-side photo
 * - title (string, required): Section heading in orange
 * - subtext (string, required): Paragraph below the title in white
 * - items (string[], required): List of feature items rendered with shield icons
 * - disclaimer (string, optional): Small muted text rendered below the list
 */
const PHFFeatures = ({ image, title, subtext, items, disclaimer }) => {
  return (
    <div className="flex flex-col lg:flex-row min-h-[500px]">
      {/* Left: Image */}
      <div className="lg:w-1/2">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Right: Navy content */}
      <div className="lg:w-1/2 bg-blue-navy flex items-center px-12 py-16">
        <div className="max-w-lg">
          <h2 className="!text-[36px] font-bold text-orange font-poppins text-left leading-tight mb-6">
            {title}
          </h2>
          <p className="text-white text-[16px] text-left mb-8 leading-relaxed">
            {subtext}
          </p>
          <ul className="space-y-6">
            {items.map((item, index) => (
              <li key={index} className="flex items-start gap-4">
                <svg
                  className="w-6 h-6 text-blue flex-shrink-0 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                  />
                </svg>
                <span className="text-white text-[16px] leading-relaxed text-left">{item}</span>
              </li>
            ))}
          </ul>
          {disclaimer && (
            <p className="text-blue-light1 text-[13px] text-left mt-6">{disclaimer}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PHFFeatures;
